module.exports = __webpack_public_path__ + "images/kurtosis-05-desktop.png";